import { render } from "./DefaultLayout.vue?vue&type=template&id=342b467e"
import script from "./DefaultLayout.vue?vue&type=script&lang=js"
export * from "./DefaultLayout.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\acer1\\Desktop\\TTT-Member\\Partner\\GOODLUCK711\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__